/**
 * Curated set of HTML tag names whose default browser display is "inline".
 *
 * Methodology: scraped from MDN element list, filtered by
 * `window.getComputedStyle(el).display.startsWith('inline')`.
 * Source: https://developer.mozilla.org/en-US/docs/Web/HTML/Element (as of 2023-11-06)
 *
 * Adapted from Plate (MIT): packages/core/src/lib/plugins/html/utils/inlineTagNames.ts
 */
export const InlineTagNames = new Set([
  'A',
  'ABBR',
  'ACRONYM',
  'B',
  'BDI',
  'BDO',
  'BIG',
  'BR',
  'BUTTON',
  'CANVAS',
  'CITE',
  'CODE',
  'CONTENT',
  'DATA',
  'DEL',
  'DFN',
  'EM',
  'EMBED',
  'FONT',
  'I',
  'IFRAME',
  'IMG',
  'INPUT',
  'INS',
  'KBD',
  'LABEL',
  'MAP',
  'MARK',
  'MARQUEE',
  'math',
  'MENUITEM',
  'METER',
  'NOBR',
  'OBJECT',
  'OUTPUT',
  'PICTURE',
  'PORTAL',
  'PROGRESS',
  'Q',
  'S',
  'SAMP',
  'SELECT',
  'SHADOW',
  'SMALL',
  'SOURCE',
  'SPAN',
  'STRIKE',
  'STRONG',
  'SUB',
  'SUP',
  'svg',
  'TEXTAREA',
  'TIME',
  'TRACK',
  'TT',
  'U',
  'VAR',
  'VIDEO',
  'WBR',
]);
